import React, { useEffect, useState, useRef } from "react";
import { AddToFavorite } from "../AddToFavorite";
import { Container } from "react-bootstrap";
import _ from "lodash";
import { RemoveFavorite } from "components/RemoveFavorite";
import { useLazyQuery } from "@apollo/client";
import { GET_FAVORITES } from "../../schemas/favorite";

export const FavoriteButtonsWrapper = ({ labels }) => {
    const [item, setItem] = useState({})
    const [isFavorite, setIsFavorite] = useState("");
    const [getFavorites, { loading, data }] = useLazyQuery(GET_FAVORITES, {
        fetchPolicy: "no-cache",
      });
    const nid = useRef();
    
    useEffect(() => {
        getFavorites();
        nid.current = document.getElementsByClassName("block-elementree-favoritebuttonswrapper")[0].getAttribute("current-nid");
        setItem({nid: nid.current, langcode: labels.lang});
    },[])

    useEffect(() => {
        if (!loading && data) {
            setIsFavorite(!!Utils.isFavorite(nid.current, data)) 
        }
    },[loading, data])
    
    return (
        <Container className="favorite-wrapper">
            {isFavorite == false ? (
                <AddToFavorite
                    labels={labels}
                    getAllFavorites={getFavorites}
                    item={item}
                    fromProgramPage={true}
                    registerFormLabels={labels.RegisterForm.labels}
                />
            ) : (
                <RemoveFavorite
                    getAllFavorites={ getFavorites }
                    labels={ labels }
                    item={ item }
                    fromProgramPage={ true }
                />
            )}
        </Container>
    )
}